import { createContext } from 'react';

const EditContext = createContext(null);

export default EditContext;
